import { useMemo } from "react";
import { Spin } from "antd";
import { useGetMyPaymentRequestsQuery } from "../../../store/service/paymentService";

const statusClass = (status) => {
  const s = String(status || "").toLowerCase();
  if (s === "approved") return "ok";
  if (s === "rejected") return "bad";
  return "pending";
};

const formatDate = (value) => {
  if (!value) return "—";
  const d = new Date(String(value).replace(" ", "T"));
  if (Number.isNaN(d.getTime())) return value;
  return d.toLocaleString(undefined, {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const PaymentRequestTable = ({ title, rows, emptyText, kind }) => (
  <section className="profile-req-section">
    <div className="profile-req-head">
      <h3>{title}</h3>
      <span>
        {rows.length} record{rows.length === 1 ? "" : "s"}
      </span>
    </div>
    <div className="profile-req-scroll">
      <table className="profile-req-table">
        <thead>
          <tr>
            <th>Date</th>
            <th>Amount</th>
            {kind === "deposit" ? <th>UTR</th> : <th>Account</th>}
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 ? (
            <tr>
              <td colSpan={4} className="profile-req-empty">
                {emptyText}
              </td>
            </tr>
          ) : (
            rows.map((row) => (
              <tr key={row.id}>
                <td>{formatDate(row.createdAt)}</td>
                <td className="num">{Number(row.amount || 0).toFixed(2)}</td>
                <td className="mono">
                  {kind === "deposit" ? row.utr || "—" : row.userAccountNumber || "—"}
                </td>
                <td>
                  <span className={`profile-status ${statusClass(row.status)}`}>
                    {row.status || "pending"}
                  </span>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  </section>
);

/**
 * @param {"all"|"deposit"|"withdrawal"} [filter]
 */
const ClientPaymentRequestTables = ({ filter = "all" }) => {
  const { data, isLoading, isFetching } = useGetMyPaymentRequestsQuery(undefined, {
    pollingInterval: 20000,
  });

  const allRequests = useMemo(
    () => (Array.isArray(data?.data) ? data.data : []),
    [data]
  );

  const deposits = useMemo(
    () => allRequests.filter((r) => r.type === "deposit"),
    [allRequests]
  );
  const withdrawals = useMemo(
    () => allRequests.filter((r) => r.type === "withdrawal"),
    [allRequests]
  );

  if (isLoading && !allRequests.length) {
    return (
      <div className="profile-inline-loading">
        <Spin size="small" />
      </div>
    );
  }

  const showDeposit = filter === "all" || filter === "deposit";
  const showWithdrawal = filter === "all" || filter === "withdrawal";

  return (
    <div className="lotus-pay-requests">
      {showDeposit ? (
        <PaymentRequestTable
          title="Deposit requests"
          rows={deposits}
          kind="deposit"
          emptyText="No deposit requests yet."
        />
      ) : null}
      {showWithdrawal ? (
        <PaymentRequestTable
          title="Withdrawal requests"
          rows={withdrawals}
          kind="withdrawal"
          emptyText="No withdrawal requests yet."
        />
      ) : null}
      {isFetching ? <div className="profile-refresh">Updating requests…</div> : null}
    </div>
  );
};

export default ClientPaymentRequestTables;
